import {
    AllEvents,
    EntitledToView,
    PublicationType,
    RequiredAccess,
} from '@news-mono/web-common'
import H from 'history'
import React from 'react'
import { Logger } from '@west-australian-newspapers/typescript-log'
import { createIsEntitledChangeHandler } from './createIsEntitledChangeHandler'

export interface ShorthandBreachProps {
    requiredAccess: RequiredAccess
    location: H.Location
    onEvent: (event: AllEvents) => void
    article: PublicationType
    log: Logger
    breach: React.ReactElement<any>
}

export const ShorthandBreach: React.FC<ShorthandBreachProps> = (props) => {
    const { requiredAccess, location, onEvent, article, breach } = props

    return (
        <EntitledToView
            requiredAccess={requiredAccess}
            articleSlug={article.slug}
            onIsEntitledChange={createIsEntitledChangeHandler(
                location,
                onEvent,
                article,
            )}
            entitled={() => {
                return <div>{props.children}</div>
            }}
            notEntitled={() => {
                return <div>{breach}</div>
            }}
        />
    )
}

ShorthandBreach.displayName = 'ShorthandBreach'
